import images from "./images";

const home = [
  {
    id: 1,
    image: images.home1,
    subtitle: "Welcome to Lumina",
    title: "Your Design Partner for Inspiring Interiors",
    buttonText: "About Us",
    buttonLink: "About-us",
  },
  {
    id: 2,
    image: images.home2,
    subtitle: "Welcome to Lumina",
    title: "Elevate Your Spaces with Innovative Designs",
    buttonText: "About Us",
    buttonLink: "About-us",
  },
  {
    id: 3,
    image: images.home3,
    subtitle: "Welcome to Lumina",
    title: "Designing Your Dreams into Reality",
    buttonText: "About Us",
    buttonLink: "About-us",
  },
];

export default home;